import styled, { createGlobalStyle, StyledComponent } from 'styled-components';

import { FlexBoxCol } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import WideContainer, { IProps, wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Select, { SelectProps } from '@r1-frontend/ui-react/components/select/select';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const GlobalStyle = createGlobalStyle<{ $active: boolean }>`
    body {
        overflow: ${({ $active }) => $active ? 'hidden' : 'auto'};
    }
`;

export const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 40px 0;
    background: ${COLORS.BgMain};
    overflow-y: auto;
    z-index: 9999;
`;

export const ContentWrapper: StyledComponent<typeof WideContainer, any, IProps> = styled(WideContainer)`
    flex-direction: column;
    align-items: flex-start;
    row-gap: 20px;
    color: ${COLORS.TextPrimary};
    display: flex;
`;

export const DropDown: StyledComponent<typeof Select, any, SelectProps> = styled(Select)`
    width: 100%;

    input {
        width: 100% !important;
        opacity: 1 !important;
    }

    span {
        background: url("/static/images/icons/search.svg");
        height: 20px;
        width: 20px;
        transform: none;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        width: 40%;
    }
`;

export const ColumnsWrapper = styled.div`
    position: relative;
    flex-wrap: nowrap;
    width: 100%;
    display: flex;
`;

export const Column = styled(FlexBoxCol)`
    flex-basis: 100%;
    flex-direction: column;
    row-gap: 20px;
    display: flex;
  
    @media (min-width: ${wideBreakpoints.mobile}) {
        flex-basis: 50%;
    }

    @media (min-width: ${wideBreakpoints.tablet}) {
        flex-basis: calc(100% / 3);
    }

    @media (min-width: ${wideBreakpoints.laptop}) {
        flex-basis: 25%;
    }
`;

export const RegionsWrapper = styled.div`
    position: relative;
    flex-direction: column;
    break-inside: avoid;
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    row-gap: 15px;
    padding-left: 50px;
    display: flex;
  
    @media (min-width: ${wideBreakpoints.mobile}) {
        position: static;
        padding-left: 0;
    }
`;

export const RegionsLetter = styled.p`
    position: absolute;
    top: 0;
    left: 0;
    color: ${COLORS.Logo};
    ${FONTS.L};

    @media (min-width: ${wideBreakpoints.mobile}) {
        position: static;
    }
`;
